module.exports = __webpack_public_path__ + "static/img/time_2.c23d714f.webp";